/**
 * Used to determine roughly the size a value will be in the database based on it's
 * contents.
 */
export function roughSizeOfObject(obj: any) {
	const objectList = [];
	const stack = [obj];
	let bytes = 0;

	while (stack.length) {
		const value = stack.pop();

		if (typeof value === 'boolean') {
			bytes += 4;
		} else if (typeof value === 'string') {
			bytes += value.length * 2; // Assuming UTF-16 encoding
		} else if (typeof value === 'number') {
			bytes += 8;
		} else if (
			typeof value === 'object' &&
			objectList.indexOf(value) === -1
		) {
			objectList.push(value);
			for (const i in value) {
				stack.push(value[i]);
			}
		}
	}
	return bytes;
}

export const clone = <T>(value: T): T => JSON.parse(JSON.stringify(value));
